import { SearchComponent } from './search.component';
export var searchRoutes = [
    {
        path: 'search',
        component: SearchComponent
    },
];
var SearchRoutingModule = (function () {
    function SearchRoutingModule() {
    }
    return SearchRoutingModule;
}());
export { SearchRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/search/search-routing.module.ts.pre-build-optimizer.js